import React from "react";
import {Button} from "react-bootstrap";
import {ADMIN_LANG} from "../../settings";

type Props = {
    src: string
    alt?: string
    kind?: 'image' | 'video'
    onAction: () => void
    actionLabel?: string
    backdropColor?: string
    children?: React.ReactNode
}

// The shared "uploaded media + change button" row. There is deliberately no width prop: sizing lives
// entirely in .media-preview-row (see _admin.scss). The previous copies of this markup sized the media
// with an HTML width attribute, and the one caller that left it at 'auto' got no attribute at all -
// 'auto' is not a valid dimension value - so the media claimed the whole flex line and pushed the
// button out of the modal.
//
// The media and the button must stay DIRECT siblings of the row: callers (and ElementModal.test.tsx)
// reach the button from the media via parentElement. That is why a backdrop colour is painted onto the
// media itself rather than by wrapping it in a coloured div.
const MediaPreview = ({
                          src,
                          alt = '',
                          kind = 'image',
                          onAction,
                          actionLabel = ADMIN_LANG.change_remove,
                          backdropColor,
                          children
                      }: Props) => {

    const className = backdropColor ? 'rounded p-2' : 'rounded';
    const style = backdropColor ? {backgroundColor: backdropColor} : undefined;

    return (
        <div className='media-preview-row'>
            {kind === 'video'
                ? <video src={src} className={className} style={style}/>
                : <img src={src} alt={alt} className={className} style={style}/>
            }
            <Button variant='secondary' onClick={onAction}>{actionLabel}</Button>
            {children}
        </div>
    );
}

export default MediaPreview;
